import type { FormCapabilities } from 'app/utils/applications/formCapabilities'
import { resolveFormCapabilities } from 'app/utils/applications/formCapabilities'

type EditSummaryPetsApplication = {
  isManagerAdded?: boolean
  managerAddedPets?: number
}

type EditSummaryPetsSummary = {
  isManagerAddedPetsSource?: boolean
  managerAddedPets?: number
  pets?: number
}

type EditSummaryPetsParams = {
  formCapabilities?: Partial<FormCapabilities> | undefined
  application?: EditSummaryPetsApplication | undefined
  managerEditedSummary?: EditSummaryPetsSummary | undefined
}

const hasManagerAddedPets = (value?: number): boolean => Number(value ?? 0) > 0

export const isManagerPetsSource = ({
  application,
  managerEditedSummary,
}: EditSummaryPetsParams = {}): boolean =>
  Boolean(application?.isManagerAdded) ||
  Boolean(managerEditedSummary?.isManagerAddedPetsSource) ||
  hasManagerAddedPets(managerEditedSummary?.managerAddedPets) ||
  hasManagerAddedPets(application?.managerAddedPets)

export const shouldBlankRenterPets = ({
  formCapabilities,
  application,
  managerEditedSummary,
}: EditSummaryPetsParams = {}): boolean =>
  !resolveFormCapabilities(formCapabilities).hasPetDetails &&
  !isManagerPetsSource({ application, managerEditedSummary })

export const getEditSummaryPetsValue = ({
  formCapabilities,
  application,
  managerEditedSummary,
}: EditSummaryPetsParams = {}): number | '' => {
  if (
    shouldBlankRenterPets({
      formCapabilities,
      application,
      managerEditedSummary,
    })
  ) {
    // Display intentionally stays blank; the save path sends 0 only if the PM edits Pets.
    return ''
  }

  if (isManagerPetsSource({ application, managerEditedSummary })) {
    return (
      managerEditedSummary?.managerAddedPets ??
      application?.managerAddedPets ??
      0
    )
  }

  return managerEditedSummary?.pets ?? 0
}
